'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlotCandlestickIcon = function PlotCandlestickIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 32 32' }, props),
        _react2.default.createElement('path', { d: 'M11.563 4.688h-2.25v-4c.063-.188 0-.313-.125-.438C9.125.125 8.938 0 8.813 0H7.438a.71.71 0 0 0-.5.188.568.568 0 0 0-.25.5v4h-2c-.938 0-2-.438-2 1.313v20a2.26 2.26 0 0 0 2 2h2v3.313c0 .188.063.375.25.5a.71.71 0 0 0 .5.188h1.375c.125 0 .313-.125.375-.25.125-.125.188-.25.125-.438v-3.313h2.25c1-.125 1.75-1 1.75-2v-20c0-.938-.875-1.313-1.75-1.313zM11.313 26H4.688V6.687h6.625zm16.25-17.312h-2.25v-8c.063-.188 0-.313-.125-.438-.063-.125-.25-.25-.375-.25h-1.375a.71.71 0 0 0-.5.188.568.568 0 0 0-.25.5v8h-2c-.938 0-2-.438-2 1.313v12a2.26 2.26 0 0 0 2 2h2v7.313c0 .188.063.375.25.5a.71.71 0 0 0 .5.188h1.375c.125 0 .313-.125.375-.25.125-.125.188-.25.125-.438v-7.313h2.25c1-.125 1.75-1 1.75-2v-12c0-.938-.875-1.313-1.75-1.313z' })
    );
};

exports.default = PlotCandlestickIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/plotly-icons/lib/components/PlotCandlestickIcon.js
// module id = 652
// module chunks = 0